[
  {
    "id": 1,
    "topText": "TAP INTO THE",
    "mainText": "ENTERTAINMENT TRAVELER",
    "infoText": "Meet guests seeking live events, and concerts and festivals.",
    "videoAsset": "LiveEntertainmentTraveler.mp4"
  },
  {
    "id": 2,
    "topText": "TAP INTO THE",
    "mainText": "SPORTS TRAVELER",
    "infoText": "Connect to sport fans with repeat bookings for tournaments.",
    "videoAsset": "SportTraveler.mp4"
  },
  {
    "id": 3,
    "topText": "TAP INTO THE",
    "mainText": "OUTDOOR TRAVELER",
    "infoText": "Reach travelers chasing their new edge.",
    "videoAsset": "AdventureTraveler.mp4"
  },
  {
    "id": 4,
    "topText": "TAP INTO THE",
    "mainText": "GLOBAL TRAVELER",
    "infoText": "Meet high-value, frequent long-haul travelers.",
    "videoAsset": "InternationalTraveler.mp4"
  }
]
